import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "font-semibold text-24px text-black-lp-300" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-normal text-12px xxl:text-14px text-gray-lp-600" }, " 30 hari terakhir ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", {
    class: `grid grid-cols-${_ctx.column} gap-6 mt-4`
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dashboardDeliveryData, (item, index) => {
      return (_openBlock(), _createBlock(_component_Card, {
        key: index,
        title: item.title,
        tooltipDescription: item.description,
        iconRight: item.icon,
        isTooltip: "",
        isArrowRight: (index + 1) % _ctx.column !== 0
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(item.totalStt), 1),
          _hoisted_2
        ]),
        _: 2
      }, 1032, ["title", "tooltipDescription", "iconRight", "isArrowRight"]))
    }), 128))
  ], 2))
}